import { closeModal, openModal } from '@components/modals';
import { execOnLoad } from '@general/helpers';
import './mobile-menu.scss';
import breakpoints from 'breakpoints';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initMobileMenu = (context) => {
  const snippetContainer = context.classList.contains('.mobile-menu__container')
    ? context
    : context.closest('.mobile-menu__container');
  if (!snippetContainer) return;
  const header = document.querySelector('.header__background');
  const menuButton = snippetContainer.querySelector('.mobile-menu__icon');
  const modal = snippetContainer.querySelector('.modal');
  const enableTransparency = header.hasAttribute('data-transparent');
  if (!menuButton || !modal) return;

  menuButton.addEventListener('click', () => {
    if (modal.classList.contains('open')) {
      snippetContainer.classList.remove('open');
      closeModal(modal);
      if (enableTransparency) header.dataset.transparent = 'true';
      snippetContainer
        .querySelectorAll('.mobile-menu__second-level.open')
        .forEach((secondLevel) => secondLevel.classList.remove('open'));
    } else {
      const announcementHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--announcement-bar-height',
        ),
      );
      if (window.scrollY < announcementHeight)
        window.scrollTo({ top: announcementHeight, behavior: 'smooth' });

      snippetContainer.classList.add('open');
      openModal(modal);
      if (enableTransparency) header.dataset.transparent = 'false';
    }
  });

  const lgUp = window.matchMedia(`(min-width: ${breakpoints.lg})`);
  const handleNavigation = () => {
    if (lgUp.matches && snippetContainer.classList.contains('open')) {
      snippetContainer.classList.remove('open');
      closeModal(modal);
      if (enableTransparency) header.dataset.transparent = 'true';
      snippetContainer
        .querySelectorAll('.mobile-menu__second-level.open')
        .forEach((secondLevel) => secondLevel.classList.remove('open'));
      snippetContainer
        .querySelectorAll('.mobile-menu__third-level.open')
        .forEach((thirdLevel) => thirdLevel.classList.remove('open'));
    }
  };
  lgUp.addEventListener('change', handleNavigation);
  snippetContainer
    .querySelectorAll('.mobile-menu__first-level--openable')
    .forEach((firstLevel) => {
      const secondLevel = firstLevel.querySelector(
        '.mobile-menu__second-level',
      );
      const opener = firstLevel.querySelector('.mobile-menu__first-level-link');
      if (!secondLevel || !opener) return;
      opener.addEventListener('click', () => secondLevel.classList.add('open'));
    });

  snippetContainer
    .querySelectorAll('.mobile-menu__second-level')
    .forEach((secondLevel) => {
      const close = secondLevel.querySelector('.mobile-menu__back');
      if (!close) return;
      close.addEventListener('click', () =>
        secondLevel.classList.remove('open'),
      );
    });

  snippetContainer
    .querySelectorAll('.mobile-menu__second-level__item--openable')
    .forEach((secondLevel) => {
      const thirdLevel = secondLevel.querySelector('.mobile-menu__third-level');
      const opener = secondLevel.querySelector(
        '.mobile-menu__second-level-link',
      );
      if (!thirdLevel || !opener) return;
      opener.addEventListener('click', () => thirdLevel.classList.add('open'));
    });

  snippetContainer
    .querySelectorAll('.mobile-menu__third-level')
    .forEach((thirdLevel) => {
      const close = thirdLevel.querySelector('.mobile-menu__third-level__back');
      if (!close) return;
      close.addEventListener('click', () =>
        thirdLevel.classList.remove('open'),
      );
    });
};

execOnLoad(window.dAgency.initMobileMenu, '.mobile-menu__container');
